import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  viewId: any = 'all'
  query: string = 'limit=10&page=1'
  private http = inject(HttpClient)

  getOrders(params?: any) {
    return this.http.get(`${environment.baseUrl}/order/vendor`, { params })
  }
  getMetrics(params?: any) {
    return this.http.get(`${environment.baseUrl}/order/metrics`, { params })
  }
  getTags(params?: any) {
    return this.http.get(`${environment.baseUrl}/order/tags`, { params })
  }
  getViews() {
    return this.http.get(`${environment.baseUrl}/order/views`)
  }

  addView(data: any) {
    return this.http.post(`${environment.baseUrl}/order/views`, data)
  }
  addOrder(data: any) {
    return this.http.post(`${environment.baseUrl}/order/vendor/create`, data)
  }

  // --- Draft orders ---
  addDraft(data: any) {
    return this.http.post(`${environment.baseUrl}/order/draft`, data)
  }
  getDrafts(params?: any) {
    return this.http.get(`${environment.baseUrl}/order/draft`, { params })
  }
  getDraft(id: string) {
    return this.http.get(`${environment.baseUrl}/order/draft/${id}`)
  }
  updateDraft(id: string, data: any) {
    return this.http.patch(`${environment.baseUrl}/order/draft/${id}`, data)
  }
  deleteDraft(id: string) {
    return this.http.delete(`${environment.baseUrl}/order/draft/${id}`)
  }
  completeDraft(id: string, data: any = {}) {
    return this.http.post(`${environment.baseUrl}/order/draft/${id}/complete`, data)
  }
  refundOrder(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/vendor/refund/${orderId}`, data)
  }
  sendInvoice(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/${orderId}/payment/send-invoice`, data)
  }
  restockOrder(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/vendor/restock/${orderId}`, data)
  }
  editTracking(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/fulfillment/${orderId}/edit-tracking`, data)
  }

  fulfillmentHold(orderId: string, action: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/fulfillment-hold/${orderId}?action=${action}`, data)
  }

  packingSlip(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/packing-slip/${orderId}`, data)
  }
  markAsPaid(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/collect-payment/${orderId}`, data)
  }
  archive(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/vendor/archive/${orderId}`, data)
  }
  createCustomer(orderId: string, data: any) {
    return this.http.post(`${environment.baseUrl}/customer?orderId=${orderId}`, data)
  }

  updateView(viewId: any, data: any) {
    return this.http.patch(`${environment.baseUrl}/order/views/${viewId}`, data)
  }

  deleteView(viewId: any) {
    return this.http.delete(`${environment.baseUrl}/order/views/${viewId}`)
  }

  getSingleOrder(id: string) {
    return this.http.get(`${environment.baseUrl}/order/details/${id}`)
  }

  getOrderJourney(orderId: string) {
    return this.http.get(`${environment.baseUrl}/order/details/${orderId}/journey`)
  }

  exportOrder(id: string) {
    return this.http.get(`${environment.baseUrl}/order/track/${id}/export`, {
      responseType: 'blob',
    })
  }

  importOrders(data: any) {
    return this.http.post(`${environment.baseUrl}/order/import`, data)
  }

  exportOrders() {
    return this.http.get(`${environment.baseUrl}/order/vendor/export`, {
      responseType: 'blob',
    })
  }

  duplicateOrder(id: string) {
    return this.http.get(`${environment.baseUrl}/order/duplicate/${id}`)
  }

  cancelOrder(id: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/vendor/cancel/${id}`, data)
  }
  cancelFulfillment(orderId: string, fulfillmentId: any) {
    return this.http.post(`${environment.baseUrl}/order/fulfillment/${orderId}/cancel/${fulfillmentId}`, {})
  }
  updateOrder(id: string, data: any) {
    return this.http.patch(`${environment.baseUrl}/order/${id}`, data)
  }
  updateItemsOrder(id: string, data: any) {
    return this.http.patch(`${environment.baseUrl}/order/${id}/items`, data)
  }
  fulfillmentOrder(id: string, data: any) {
    return this.http.post(`${environment.baseUrl}/order/fulfillment/${id}`, data)
  }
  addCommentToOrder(orderId: string, content: string) {
    return this.http.post(`${environment.baseUrl}/order/${orderId}/comments`, { content, attachment: null })
  }

  getCountries(params?: any) {
    return this.http.get(`${environment.baseUrl}/geo/countries`, { params })
  }

  getStates(params?: any) {
    return this.http.get(`${environment.baseUrl}/geo/states`, { params })
  }
  getTimezones() {
    return this.http.get(`${environment.baseUrl}/public/timezones`)
  }

  addExportJob(data: any) {
    return this.http.post(`${environment.baseUrl}/order/export-jobs`, data)
  }

  getJobs(params?: any) {
    return this.http.get(`${environment.baseUrl}/order/export-jobs`, { params })
  }

  getJobById(id: string) {
    return this.http.get(`${environment.baseUrl}/order/export-jobs/${id}`)
  }

  updateJob(id: string, data: any) {
    return this.http.patch(`${environment.baseUrl}/order/export-jobs/${id}`, data)
  }

  deleteJob(id: string) {
    return this.http.delete(`${environment.baseUrl}/order/export-jobs/${id}`)
  }

  enableJob(id: string) {
    return this.http.post(`${environment.baseUrl}/order/export-jobs/${id}/enable`, {})
  }

  disableJob(id: string) {
    return this.http.post(`${environment.baseUrl}/order/export-jobs/${id}/disable`, {})
  }

  runJobManually(id: string) {
    return this.http.post(`${environment.baseUrl}/order/export-jobs/${id}/run`, {})
  }

  getJobRuns(id: string, params?: any) {
    return this.http.get(`${environment.baseUrl}/order/export-jobs/${id}/runs`, { params })
  }

  resendDownloadLink(orderId: string) {
    return this.http.post(`${environment.baseUrl}/order/vendor/${orderId}/resend-download`, {})
  }

  revokeDownloads(orderId: string) {
    return this.http.post(`${environment.baseUrl}/order/vendor/${orderId}/revoke-downloads`, {})
  }

  restoreAccess(orderId: string) {
    return this.http.post(`${environment.baseUrl}/order/vendor/${orderId}/restore-downloads`, {})
  }
}
